import React from "react"
import { Provider } from "react-redux"
import { createStore, applyMiddleware, compose } from "redux"
import thunk from "redux-thunk"
import { isBrowser } from "../lib"
import rootReducer from "./index"
// import context
import { DrawerProvider } from '../contexts/DrawerContext'



const composeEnhancers =
  (isBrowser() && window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__) || compose

const middleware = [thunk]

const store = createStore(
  rootReducer,
  composeEnhancers(applyMiddleware(...middleware))
)

export default ({ element }) => <Provider store={store}>
    <DrawerProvider>
      {element}
    </DrawerProvider>
  </Provider>
